/*global payhere*/
import React from "react";
import { useNavigate } from "react-router-dom";

const PaymentButton = ({ formData }) => {
  const navigate = useNavigate();
  const paymentDetails = {
    order_id: formData?.orderId,
    amount: parseFloat(formData?.price).toFixed(2),
    currency: "LKR",
    first_name: formData?.firstName,
    last_name: formData?.lastName,
    email: formData?.email,
    phone: formData?.phone,
    address: formData?.address,
    clinicid: formData?.clinicid,
    startDate: formData?.startDate,
    months: formData?.months,
    city: "Colombo",
    country: "Sri Lanka",
  };

  const handlePayment = async () => {
    try {
      // Request backend to generate the hash value
      const response = await fetch(
        `${process.env.REACT_APP_API}/client/payhere/start`,
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify(paymentDetails),
        }
      );

      if (response.ok) {
        const { hash, merchant_id } = await response.json();
        const payment = {
          merchant_id: merchant_id,
          return_url: undefined, // Important
          cancel_url: undefined, // Important
          notify_url: `${process.env.REACT_APP_API}/client/payhere/notify`,
          order_id: paymentDetails.order_id,
          items: "Item Title",
          amount: paymentDetails.amount,
          currency: paymentDetails.currency,
          first_name: paymentDetails.first_name,
          last_name: paymentDetails.last_name,
          email: paymentDetails.email,
          phone: paymentDetails.phone,
          address: paymentDetails.address,
          city: paymentDetails.city,
          country: paymentDetails.country,
          hash: hash,
          custom_1: paymentDetails.clinicid,
          custom_2: paymentDetails.startDate + "%" + paymentDetails.months,
        };

        payhere.startPayment(payment);

        payhere.onCompleted = function onCompleted(orderId) {
          navigate("/payment/success");
        };
        payhere.onDismissed = function onDismissed() {
          navigate("/payment/cancel");
        };

        payhere.onError = function onError(error) {
          navigate("/payment/error");
        };
      } else {
        console.error("Failed to generate hash for payment.");
      }
    } catch (error) {
      console.error("An error occurred:", error);
    }
  };

  return <button onClick={handlePayment}>PayHere Pay</button>;
};

export default PaymentButton;
